import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StorageProvider} from './storage';
import {NavParamService} from './navparams';
import {Router} from '@angular/router';
import {ApiCall} from '../utils/api/apicall';
import {ApiJsonResult} from '../utils/api/apijsonresult';
import {BaseProvider} from './base';
import {ChildProgressLevelTracker} from './db/ChildProgressLevelTracker';
import {ScopeQuestionareInProgress} from './db/ScopeQuestionareInProgress';
import {ScopeActivityTrackerInProgress} from './db/ScopeActivityInProgress';
import {ProgramDashboard} from './db/ProgramDashboard';
import {ActivityTracker} from './db/ActivityTracker';
import {FeedbackTracker} from './db/FeedbackTracker';
import {FeedbackMaster} from './db/FeedbackMaster';
import {Editt} from './db/Editt';

@Injectable({
    providedIn: 'root'
})
export class ScopeProgramService extends BaseProvider {

    constructor(public http: HttpClient, public storage: StorageProvider,
                public navService: NavParamService, public router: Router) {
        super(http, storage, navService, router);
    }

    public dashboard(childId: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/dashboard/' + childId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const output = ProgramDashboard.apimapper(apijsonResult);
                resolve(output);
            }, (err) => {
                reject(err);
            });
        });
    }

    public upgrade(childId: any, parentFeedbackId: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/upgrade/' + childId + '/' + parentFeedbackId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const output = ProgramDashboard.apimapper(apijsonResult);
                resolve(output);
            }, (err) => {
                reject(err);
            });
        });
    }

    progressTracker(childId: any) {
        const apiCall = ApiCall.getter('scopev2', '/assessment/progress/report/' + childId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const single = ChildProgressLevelTracker.apimapper(apijsonResult);
                resolve(single);
            }, (err) => {
                reject(err);
            });
        });
    }

    progressTrackerList(childId: any) {
        const apiCall = ApiCall.getter('scopev2', '/assessment/progress/reportlist/' + childId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const list = ChildProgressLevelTracker.apimapperLst(apijsonResult);
                resolve(list);
            }, (err) => {
                reject(err);
            });
        });
    }

    goals(childId: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/goals/current/' + childId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                resolve(apijsonResult.outputjson);
            }, (err) => {
                reject(err);
            });
        });
    }

    parentQuestionare(childId: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/questionare/current/' + childId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const single = ScopeQuestionareInProgress.apimapper(apijsonResult);
                resolve(single);
            }, (err) => {
                reject(err);
            });
        });
    }

    questionareResponse(questionInProgressId: any, response: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/questionare/response/' + questionInProgressId + '/' + response);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const lst = ScopeQuestionareInProgress.apimapper(apijsonResult);
                resolve(lst);
            }, (err) => {
                reject(err);
            });
        });
    }

    activityList(childId: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/activity/current/' + childId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const single = ScopeActivityTrackerInProgress.apimapper(apijsonResult);
                resolve(single);
            }, (err) => {
                reject(err);
            });
        });
    }

    activityResponse(activityId: any, response: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/activity/response/' + activityId + '/' + response);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const single = ScopeActivityTrackerInProgress.apimapper(apijsonResult);
                resolve(single);
            }, (err) => {
                reject(err);
            });
        });
    }

    resetProgram(childId: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/reset/program/' + childId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                resolve(apijsonResult);
            }, (err) => {
                reject(err);
            });
        });
    }


    activityArchiveLst(childProgressReportId: any) {
        const apiCall = ApiCall.getter('scopev2', '/archive/activity/tracker/' + childProgressReportId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const lst = ActivityTracker.apimapperLst(apijsonResult);
                resolve(lst);
            }, (err) => {
                reject(err);
            });
        });
    }

    feedbackArchiveLst(childId: any) {
        const apiCall = ApiCall.getter('scopev2', '/archive/feedback/tracker/' + childId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const lst = FeedbackTracker.apimapperLst(apijsonResult);
                resolve(lst);
            }, (err) => {
                reject(err);
            });
        });
    }

    questionsforActivity(activityId: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/activity/feedback/' + activityId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const lst = FeedbackMaster.apimapperLst(apijsonResult);
                resolve(lst);
            }, (err) => {
                reject(err);
            });
        });
    }

    saveActivityResponse(activityId: any, lst: FeedbackMaster[]) {
        const apiCall = ApiCall.postjson('scopev2', '/program/activity/response/' + activityId, JSON.stringify(lst));
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                resolve(apijsonResult.responseCode);
            }, (err) => {
                reject(err);
            });
        });
    }

    activityLog(activity: ScopeActivityTrackerInProgress) {
        const apiCall = ApiCall.getter('scopev2', '/program/activity/log/' +
            activity.childProgressLevelTrackerId + '/' + activity.activityMasterId);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const lst = ActivityTracker.apimapperLst(apijsonResult);
                resolve(lst);
            }, (err) => {
                reject(err);
            });
        });
    }

    edittById(id: any) {
        const apiCall = ApiCall.getter('scopev2', '/program/editt/byid/' + id);
        return new Promise((resolve, reject) => {
            super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
                const single = Editt.apimapper(apijsonResult);
                resolve(single);
            }, (err) => {
                reject(err);
            });
        });
    }


}
